<template>

<otif-modal ref="rdbmsConnectionStrings" v-bind:title="ecmResourceStrings.ttlConnectionStringTemplate" :value="value" @input="$emit('input', $event)" @shown="onShown">
<b-form>
    <ecmconnection-select
        v-model="$v.selectedSet"
        v-bind:label="ecmResourceStrings.lblDriver"
        :parameters="paramSets"
        :selectedSet="selectedSet"
        ref="driver_selector"
        @reselected="reselected"/>
    <otif-textarea
        v-model="$v.form.description.$model"
        v-bind:label="ecmResourceStrings.lblUseTemplate"
        ref="first_input" />
        
</b-form>
<template slot="footer">
    <otif-button className=" OTPrimary" @click.native="setTemplate" >{{ecmResourceStrings.lblPopulate}}</otif-button>
    <otif-button className=" OTSecondary" @click.native="cancel">{{ecmResourceStrings.lblCancel}}</otif-button>
</template>
</otif-modal>

</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import EcmRepositoryConnections from '../../../ecm/components/widgets/ECMRepositoryConnections.vue';

const defaultTemplates = {
    '1':'DRIVER={OpenText 8.0 SQL Server Wire Protocol};HOST=;SERVER=;PORT=1433;DB=;UID=;PWD=;WorkArounds2=2;TimestampTruncationBehavior=1',
    '2': 'DRIVER={OpenText 8.0 Oracle Wire Protocol};HOST=;ServiceName=;UID=;PWD=;WorkArounds2=2;TimestampTruncationBehavior=1',
    '0':'DRIVER={DataDirect 7.1 PostgreSQL Wire Protocol};DSN=; HOST=;PORT=;DB=;UID=;PWD=;WorkArounds2=2;TimestampTruncationBehavior=1;IANAAppCodePage=106',
};

export default {
    components: {
        'ecmconnection-select': EcmRepositoryConnections,
    },
    props: ['value'],
    mixins: [
        validationMixin
    ],
    data() {
        return {
            paramSets : [
                    {description: 'PostgreSQL', index: 0},
                    {description: 'SQL', index: 1},
                    {description: 'Oracle', index: 2}
                ],
           
            selectedSet:'0',
            ecmResourceStrings: require('../../utils/resourceECM.js'),
            form: {
                description: '',
            }
        }
    },

    validations: {     
        form:{
            description: { required, isUnique(value) {
                if (value === '') return true;
            }}
        }
    },

    methods: {
        onShown() {
            this.form.description = 'DRIVER={DataDirect 7.1 PostgreSQL Wire Protocol};DSN=; HOST=;PORT=;DB=;UID=; PWD=;WorkArounds2=2;TimestampTruncationBehavior=1;IANAAppCodePage=106';
        },

        cancel() {
            this.$emit('input', false);
        },

        setTemplate() {
            this.$parent.setTemplate(this.form.description);
            this.$emit('input', false);
        },

        reselected(value) {
           var that = this;
           this.selectedSet=value;
           this.form.description = defaultTemplates[value];
        },
    },
}

</script>
